import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SandblastMobileIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#6568cd' : this.getColor()
    return [
      <g>
        <path fill={ color }
              d="M2,10.82V25.18a3.79,3.79,0,0,0,1.92,3.26l12,7a4.13,4.13,0,0,0,4.16,0l12-7A3.79,3.79,0,0,0,34,25.18V10.82a3.79,3.79,0,0,0-1.92-3.26l-12-7a4.13,4.13,0,0,0-4.16,0l-12,7A3.79,3.79,0,0,0,2,10.82Z"/>
        <path fill={ '#fff' }
              d="M29,11.14a1.13,1.13,0,0,0-1.29.25L23,14.71,19.16,8.37A1,1,0,0,0,17.78,8a1,1,0,0,0-.33,1.37l4.4,7.25a1,1,0,0,0,1.43.3l4-2.84-1.11,9.59H10.39L9.28,14.12l4,2.84a1,1,0,0,0,.78.16,1,1,0,0,0,.65-.46l3-4.88L16.59,9.93a.59.59,0,0,1,0-.08l-3,4.86-5-3.5a1,1,0,0,0-1.08,0,1,1,0,0,0-.49,1L8.5,24.81a1,1,0,0,0,1,.9H27.11a1,1,0,0,0,1-.89l1.47-12.67A1,1,0,0,0,29,11.14Z"/>
      </g>

    ]
  }
  getViewBox = () => '0 0 36 36'
}
